import { Grid } from '@material-ui/core';
import React from 'react';
import { ImageDto } from '../../../groupVisits.dtos';
import ImageCard from './imageCard';

interface IProps {
  images: ImageDto[];
}

const ImageList: React.FC<IProps> = ({ images }) => {
  return (
    <Grid container direction='row' wrap='wrap'>
      {images.map((image, i) => (
        <ImageCard key={image.id} image={image} />
      ))}
    </Grid>
  );
};

export default ImageList;
